import type { IconSvgObject } from './types';

const ClinicIcon: IconSvgObject = [
  ["path", { d: "M19.8127 20.1571L21.756 10.0522C21.9049 9.27786 21.5849 8.48827 20.9389 8.03606L13.1476 2.58216C12.459 2.10014 11.5425 2.1001 10.8539 2.58206L3.06124 8.03599C2.41507 8.48823 2.09503 9.27799 2.24406 10.0525L4.18855 20.1573C4.36974 21.0989 5.19367 21.7794 6.15252 21.7794H17.8487C18.8076 21.7794 19.6316 21.0988 19.8127 20.1571Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9991 10.2794V17.2794M8.49908 13.7794H15.4991", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ClinicIcon;
